import { Action, createReducer, on } from "@ngrx/store";
import { OverviewState } from "./core.state";
import { clearStore, getCongressionalDistrict, getCongressionalDistrictFailure, getCongressionalDistrictSuccess, getCongressmenDatatype, getCongressmenDatatypeFailure, getCongressmenDatatypeSuccess,getLegislation, getLegislationFailure, getLegislationSuccess, getParties, getPartiesFailure, getPartiesSuccess, getScorecard, getScorecardFailure, getScorecardSuccess, getStates, getStatesFailure, getStatesSuccess, getVoteTypes, getVoteTypesFailure, getVoteTypesSuccess, setCongressionalDistrict, setSelectedCongressman, setSelectedLocalUnion } from "./core.actions";

export const initialState: OverviewState = {
    loading: false,
    error: null,
    states: [],
    legislation: [],
    voteTypes: [],
    congressmenDisplayNames: [],
    selectedCongressionalDistricts: [],
    parties: [],
    selectedCongressman: null,
    scorecards: [],
    selectedLocalUnion: null,
}

export const reducer = createReducer(
    initialState,
    on(getStates, getLegislation, getVoteTypes, getCongressmenDatatype, getCongressionalDistrict, getScorecard, getParties, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(getStatesSuccess, (state, { states }) => ({
        ...state,
        loading: false,
        states: states  
    })),
    on(getStatesFailure, getVoteTypesFailure, getLegislationFailure, getCongressmenDatatypeFailure, getPartiesFailure,
        getCongressionalDistrictFailure, getScorecardFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error
    })),
    on(getLegislationSuccess, (state, { Legislation }) => ({
        ...state,
        loading: false,
        legislation: Legislation  
    })),
    
    on(getVoteTypesSuccess, (state, { voteTypes }) => ({
        ...state,
        loading: false,
        voteTypes: voteTypes  
    })),
    on(getCongressmenDatatypeSuccess, (state, { congressmenDisplayNames }) => ({
        ...state,
        loading: false,
        congressmenDisplayNames: congressmenDisplayNames  
    })),
    on(getCongressionalDistrictSuccess, (state, { congressionalDistricts }) => ({
        
        ...state,
        loading: false,
        selectedCongressionalDistricts: congressionalDistricts
    })),
    on(setCongressionalDistrict, (state, { stateId, districtNumber}) => ({
        ...state,
        selectedCongressionalDistricts: [
        { stateId, districtNumber, localUnionNumber: null } 
    ]
    })),
    on(getPartiesSuccess, (state, { parties }) => ({
        ...state,
        loading: false,
        parties
    })),
    on(setSelectedCongressman, (state, { congressman }) => ({
        ...state,
        selectedCongressman: congressman
    })),
    on(getScorecardSuccess, (state, { scorecards}) => ({
        ...state,
        loading: false,
        scorecards
    })),
    on(setSelectedLocalUnion, (state, { selectedLocalUnion }) => ({
        ...state,
        selectedLocalUnion
    })),
    on(clearStore, (state) => ({
        ...state,
        scorecards: [],
        selectedCongressionalDistricts: [],
        selectedLocalUnion: null,
        selectedCongressman: null
    }))

)

export function appReducer(state: OverviewState | undefined, action: Action) {
    return reducer(state, action);
}